
      <div class="report-card">
          <info-tooltip [description]="description"></info-tooltip>

          <div class="report-card-title" [ngSwitch]="iconType">
            <i *ngSwitchCase="'font-awesome'" class="fa fa-{{icon}}" aria-hidden="true"></i>
            <i *ngSwitchCase="'feather-icons'" [attr.data-feather]="icon"></i>
              {{title}}
          </div> {{value}}

          <div class="sub-data" *ngIf="data.length">
              <div class="data-item" *ngFor="let item of data">
                  {{item.title}} <b>{{item.value}}</b>
              </div>
          </div>
      </div>
  